"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const routes_1 = require("../../util/routes");
const AhtiLogo_1 = __importDefault(require("../custom/AhtiLogo"));
const react_router_dom_1 = require("react-router-dom");
const Tools_1 = require("../Tools");
const common_styled_components_1 = require("../common-styled-components");
const UserSection_1 = require("./UserSection");
const NavigationContext_1 = require("../../contexts/NavigationContext");
const SideContainer = styled_components_1.default.div `
  position: relative;
  min-width: 240px;
  flex-basis: 240px;
  flex-grow: 0;
  flex-shrink: 0;
  width: 240px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-right: 1px solid ${theme_1.theme.colors.grey(4)};
  border-top-left-radius: ${common_styled_components_1.DEFAULT_RADIUS};
  border-bottom-left-radius: ${common_styled_components_1.DEFAULT_RADIUS};
  padding: 0;
  box-sizing: border-box;
  background-color: white;

  @media (max-width: ${theme_1.breakpoints.desktop}px) {
    width: 200px;
    min-width: 200px;
    flex-basis: 200px;
    border-top-left-radius: ${common_styled_components_1.DEFAULT_RADIUS};
  }

  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    display: none;
  }
`;
const Content = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const SideContent = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const currentRoute = location.pathname;
    return ((0, jsx_runtime_1.jsxs)(SideContainer, { children: [(0, jsx_runtime_1.jsxs)(Content, { children: [(0, jsx_runtime_1.jsx)(AhtiLogo_1.default, { style: { marginBottom: theme_1.theme.spacing(1) } }), (0, jsx_runtime_1.jsx)(UserSection_1.UserSection, {})] }), currentRoute !== routes_1.routeNames.main && ((0, jsx_runtime_1.jsx)(Content, { children: (0, jsx_runtime_1.jsx)(NavigationSection, {}) }))] }));
};
exports.SideContent = SideContent;
const Navi = styled_components_1.default.nav `
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: ${theme_1.theme.spacing(0)};
  align-items: flex-end;
  margin-top: ${theme_1.theme.spacing(6)};
`;
const NaviRow = styled_components_1.default.div `
  text-align: right;
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(0)};
  background-color: ${(props) => props.selected ? theme_1.theme.colors.lightBlue : "transparent"};
  color: ${(props) => props.selected ? theme_1.theme.colors.white : theme_1.theme.colors.text};
  cursor: pointer;
  padding: ${theme_1.theme.spacing(1)} ${theme_1.theme.spacing(3)};
`;
const NavigationSection = () => {
    const { user, isAuthenticated } = (0, auth0_react_1.useAuth0)();
    const { navigate } = (0, NavigationContext_1.useNavigation)();
    const tools = (0, Tools_1.getTools)(user, isAuthenticated);
    const location = (0, react_router_dom_1.useLocation)();
    const currentRoute = location.pathname;
    return ((0, jsx_runtime_1.jsx)(Navi, { children: tools.map((tool) => ((0, jsx_runtime_1.jsx)(NaviRow, { selected: currentRoute === tool.path, onClick: () => navigate(tool.path), children: tool.name }, tool.name))) }));
};
